import { render, staticRenderFns } from "./CardsProducts.vue?vue&type=template&id=2bab9940&scoped=true"
import script from "./CardsProducts.vue?vue&type=script&lang=js"
export * from "./CardsProducts.vue?vue&type=script&lang=js"
import style0 from "./CardsProducts.vue?vue&type=style&index=0&id=2bab9940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab9940",
  null
  
)

export default component.exports